import {
  Component, ExistingProvider, forwardRef, HostListener, OnInit,
} from '@angular/core';
import {
  UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR, Validators,
} from '@angular/forms';
import { noop } from 'lodash';
import { ISmallstepsPreparation } from 'typings/section-types';

export const SECTION_SMALLSTEPS_PREPARATION_VALUE_ACCESSOR: ExistingProvider = {
  provide: NG_VALUE_ACCESSOR,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  useExisting: forwardRef(() => SmallstepsPreparationComponent),
  multi: true,
};

@Component({
    selector: 'app-smallsteps-preparation',
    templateUrl: './smallsteps-preparation.component.html',
    styleUrls: ['./smallsteps-preparation.component.scss'],
    providers: [SECTION_SMALLSTEPS_PREPARATION_VALUE_ACCESSOR],
    standalone: false
})
export class SmallstepsPreparationComponent implements OnInit {
  public form: UntypedFormGroup;

  /** Value we will call whenever our form is touched */
  private onTouchedCallback: Function = noop;

  /** Function we will call whenever the value changes */
  private onChangeCallback: (val: ISmallstepsPreparation) => void = noop;

  @HostListener('blur') onBlur() {
    this.onTouchedCallback();
  }

  constructor(
    public fb: UntypedFormBuilder,
  ) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      subtitle: [],
      content: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.form.valueChanges.subscribe((formValue) => {
      this.onChangeCallback(formValue);
    });
  }

  writeValue(value: ISmallstepsPreparation) {
    if (value) {
      this.form.get('title').setValue(value.title || '');
      this.form.get('subtitle').setValue(value.subtitle || '');
      this.form.get('content').setValue(value.content || '');
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
}
